/**
 * Created by sicu on 8.1.2017.
 */
var articleSearch = {
    config: {
        mode: 'n',
        spxOnly: false,
        favOnly: false,
        prefOnly: false
    },
    toggleFilters: function (element) {
        if (this.searchExists() && $('.brandTitle').is(":visible"))
            DigSearch.getApplication().getController('Search').toggleFilter();
        $('.brandTitle').fadeToggle();
    },
    searchExists: function () {
        return typeof DigSearch !== typeof undefined;
    },
    inputSearchField: function (text) {
        if (this.searchExists())
            Ext.getCmp('comboSuggest').setValue(text);
    },
    toggleFavorites: function (val) {
        if (val) {
            $('#toggleFavorites').prop('checked', val == 'true');
        }
        this.config.favOnly = $('#toggleFavorites').prop('checked');
    },
    searchMode: function (val) {
        if (val) {
            $('#searchMode').selectpicker().selectpicker('val', val)
        }

        const oldConfigMode = this.config.mode;
        this.config.mode = $('#searchMode').val();

        if (oldConfigMode === this.config.mode) {
            return;
        }

        const searchField = $('#search-field-header');
        const searchButton = $('#btn-header-search-start');

        if (!searchField || !searchButton) {
            return;
        }

        const searchString = searchField.val().trim();

        if (searchString === '') {
            return;
        }

        searchButton.trigger('click');
    },
    toggleExternal: function (val) {
        if (val) {
            $('#toggleExternal').prop('checked', val == 'true');
        }
        this.config.spxOnly = $('#toggleExternal').prop('checked');
    },
    togglePrefOnly: function (val) {
        if (val) {
            $('#togglePrefOnly').prop('checked', val == 'true');
        }
        this.config.prefOnly = $('#togglePrefOnly').prop('checked');
    },
    startSearch: function (startNow) {
        var seachVal = $('#search-field-header').val();
        if ($('#btn-header-search-start'))
            $('#btn-header-search-start').html(output.t_stop);
        if (this.searchExists()) {
            Ext.getCmp('searchModeCombo').setValue(this.config.mode);
            Ext.getCmp('chkbx_spxOnly').setValue(this.config.spxOnly);
            Ext.getCmp('chkbx_favOnly').setValue(this.config.favOnly);
            Ext.getCmp('chkbx_prefOnly').setValue(this.config.prefOnly);


            articleSearch.inputSearchField(seachVal);
            Ext.getCmp('btnSearch').fireEvent('click');
        } else { // we jump start the old post pall.
            document.articlesearch.searchStr.value = seachVal;
            document.articlesearch.searchMode.value = this.config.mode;
            document.articlesearch.noExternal.value = this.config.spxOnly;
            document.articlesearch.favOnly.value = this.config.favOnly;
            document.articlesearch.startSearch.value = startNow;
            document.articlesearch.submit();
        }
    },
    downloadSearchInstructions: function () {
        var url = 'getHelpDownloadURL.phtml?type=search&sid=' + sid;
        var win = window.open(url, '_blank');
        win.focus();
    },
    stopSearch: function () {
        if ($('#btn-header-search-start'))
            $('#btn-header-search-start').html(output.b_suchen);
    },
    addToCart: function () {
        if (this.searchExists())
            Ext.getCmp('btnBasket').fireEvent('click');

    },
    compareArticles: function () {
        if (this.searchExists())
            Ext.getCmp('showCompareArticles').fireEvent('click');
    },
    addToFavorites: function (articleId) {
        if (this.searchExists())
            Ext.getCmp('btnFav').fireEvent('click');
        else this.ajaxBackend('ajax/ArticleSearch/Favorite/AddToFavorites', articleId);
    },
    removeFromFav: function (articleId) {
        if (this.searchExists())
            Ext.getCmp('btnFavRemove').fireEvent('click');
        else this.ajaxBackend('ajax/ArticleSearch/Favorite/RemoveFromFavorites', articleId);
    },
    addToBlackList: function (articleId) {
        if (this.searchExists())
            Ext.getCmp('btnBlacklistAdd').fireEvent('click');
        else this.ajaxBackend('ajax/ArticleSearch/Blacklist/AddToBlacklist', articleId);
    },
    removeBlackList: function (articleId) {
        if (this.searchExists())
            Ext.getCmp('btnBlacklistRemove').fireEvent('click');
        else this.ajaxBackend('ajax/ArticleSearch/Blacklist/RemoveFromBlacklist', articleId);
    },
    addToPref: function (articleId) {
        if (this.searchExists())
            Ext.getCmp('btnPrefAdd').fireEvent('click');
        else this.ajaxBackend('ajax/ArticleSearch/Preference/SetPreferenced', articleId);
    },
    removePref: function (articleId) {
        if (this.searchExists())
            Ext.getCmp('btnPrefRemove').fireEvent('click');
        else this.ajaxBackend('ajax/ArticleSearch/Preference/UnsetPreferenced', articleId);

    },
    ajaxBackend: function (call, articleId) {
        if (articleId) {
            AjaxHandlerByClass(
                call,
                {articles: [{type: "SPX", article_id: articleId}]},
                function (data) {
                    if (data && !data.success)
                        notification.info(data.message);
                    else
                        location.reload();
                },
                function () {
                    notification.info('Article can not be added/removed!')
                }
            )
        }
    },
    setup: {
        header: function (searchStr) {
            if (config.displaymenu == "favorites")
                $('#search-field-header').attr("placeholder", output.t_search_for_favorites);

            if (config.displaymenu == "blacklist")
                $('#search-field-header').attr("placeholder", output.t_search_for_blacklist);
            if (searchStr) {
                $('#search-field-header').val(escape(searchStr));
            }
        },
        checkboxes: function () {
            if (typeof configs == 'undefined' || !configs.post) return;

            if (configs.post.favOnly)
                articleSearch.toggleFavorites(configs.post.favOnly);
            if (configs.post.searchMode)
                articleSearch.searchMode(configs.post.searchMode);
            if (configs.post.noExternal)
                articleSearch.toggleExternal(true);

            if (configs?.data?.config?.filter?.hideExcludeExternalCatalogsFromSearch?.enabled == 1) {
                $('#onlyFavorites').hide();
            }
            if (configs?.data?.config?.filter?.hideFavoriteSearchCheckbox?.enabled == 1) {
                $('#noOciSearch').hide();
            }
        },
        sortResultsBy: function (sortElement, direction) {
            Ext.getStore('Search').sort({
                property: sortElement,
                direction: direction// 'DESC' or 'ASC'
            })
        },
        init: function () {
            if (l_user.filter_search_prefonly == 'Y') {
                $('#togglePrefOnlyHolder').removeClass('hidden');
                if (l_user.filter_search_prefonly_default_enabled != '0') {
                    $('#togglePrefOnly').prop('checked', true);
                }
            }

            $('#articleSearchSortByPick a').on('click', function () {
                $('#articleSearchFilter').text(this.innerText);
                $('#articleSearchSortByPick').dropdown("toggle");
                articleSearch.setup.sortResultsBy(
                    this.getAttribute('data-sort'),
                    this.getAttribute('data-order')
                );
                return false;
            })
            $('#search-field-header').on('input', function () {
                articleSearch.inputSearchField(this.value)
            });
            $('#search-field-header').keyup(function (e) {
                if (e.keyCode == 13) {
                    articleSearch.startSearch($('#search-field-header').val())
                }
            });
            if (typeof $().typeahead !== 'undefined')
                $("#search-field-header").typeahead({
                    onSelect: function (item) {
                        articleSearch.startSearch(item.value);
                    },
                    autoSelect: false,
                    hint: true,
                    ajax: {
                        url: "ajax/ArticleSearch/SearchEngine/Suggest",
                        displayField: "title",
                        triggerLength: 1,
                        method: "post",
                        loadingClass: "loading-circle",
                        preDispatch: function (query) {
                            return {
                                sid: sid,
                                query: query
                            }
                        },
                        preProcess: function (data) {
                            if (data.success === false) {
                                // Hide the list, there was some error
                                return false;
                            }
                            // We good!
                            return data.data;
                        }
                    }
                })

            if (typeof config != 'undefined')
                if (config.displaymenu)
                    articleSearch.setup.header();

            //setup posts. we assume search is running.
            if (typeof configs == 'undefined')
                return;

            $('#btn-header-detail').remove()
            $('.articleSearchEl').removeClass('hidden');
            this.checkboxes();
        }
    }
}
if (window.jQuery)
    $(document).ready(function () {
        articleSearch.setup.init();
    })
